import React, { useContext, useEffect } from 'react';

import { Ctx } from 'components/CtxFormFields/CtxInputs';

function Verifone() {
  const formContext = useContext(Ctx);
  const { setEnabledSave } = formContext.values;
  useEffect(() => {
    setEnabledSave(true);
  }, [setEnabledSave]);
  return (
    <div className="d-flex flex-column flex-fill">
      <div className="jumbotron">
        <p>
          Verifone does not require any configuration inputs. It uses a
          micro-service. Install the micro-service and connect the terminal to
          the correct USB port. Use the buttons above to interact with the
          micro-service.
        </p>
      </div>
    </div>
  );
}

export default Verifone;
